/**
 * Central registry that maps every feature namespace to its three locale files.
 * Add a new feature here when you create its locales/ folder.
 */
import type { TranslationRegistry } from './types'

// ─── Auth ────────────────────────────────────────────────────────────────────
import authEs from '@/features/auth/locales/auth.es.json'
import authEn from '@/features/auth/locales/auth.en.json'
import authPt from '@/features/auth/locales/auth.pt.json'

// ─── Dashboard ───────────────────────────────────────────────────────────────
import dashboardEs from '@/features/dashboard/locales/dashboard.es.json'
import dashboardEn from '@/features/dashboard/locales/dashboard.en.json'
import dashboardPt from '@/features/dashboard/locales/dashboard.pt.json'

// ─── Layout (nav, header, common chrome) ─────────────────────────────────────
import layoutEs from '@/features/layout/locales/layout.es.json'
import layoutEn from '@/features/layout/locales/layout.en.json'
import layoutPt from '@/features/layout/locales/layout.pt.json'

// ─── Transactions ─────────────────────────────────────────────────────────────
import transactionsEs from '@/features/transactions/locales/transactions.es.json'
import transactionsEn from '@/features/transactions/locales/transactions.en.json'
import transactionsPt from '@/features/transactions/locales/transactions.pt.json'

// ─── Balances ─────────────────────────────────────────────────────────────────
import balancesEs from '@/features/balances/locales/balances.es.json'
import balancesEn from '@/features/balances/locales/balances.en.json'
import balancesPt from '@/features/balances/locales/balances.pt.json'

// ─── Send Money ───────────────────────────────────────────────────────────────
import sendMoneyEs from '@/features/send-money/locales/send-money.es.json'
import sendMoneyEn from '@/features/send-money/locales/send-money.en.json'
import sendMoneyPt from '@/features/send-money/locales/send-money.pt.json'

// ─── Notifications ────────────────────────────────────────────────────────────
import notificationsEs from '@/features/notifications/locales/notifications.es.json'
import notificationsEn from '@/features/notifications/locales/notifications.en.json'
import notificationsPt from '@/features/notifications/locales/notifications.pt.json'

// ─── Profile ──────────────────────────────────────────────────────────────────
import profileEs from '@/features/profile/locales/profile.es.json'
import profileEn from '@/features/profile/locales/profile.en.json'
import profilePt from '@/features/profile/locales/profile.pt.json'

// ─── Profiles admin ───────────────────────────────────────────────────────────
import profilesEs from '@/features/profiles/locales/profiles.es.json'
import profilesEn from '@/features/profiles/locales/profiles.en.json'
import profilesPt from '@/features/profiles/locales/profiles.pt.json'

// ─── Settings ─────────────────────────────────────────────────────────────────
import settingsEs from '@/features/settings/locales/settings.es.json'
import settingsEn from '@/features/settings/locales/settings.en.json'
import settingsPt from '@/features/settings/locales/settings.pt.json'

// ─── Register ─────────────────────────────────────────────────────────────────
import registerEs from '@/features/register/locales/register.es.json'
import registerEn from '@/features/register/locales/register.en.json'
import registerPt from '@/features/register/locales/register.pt.json'

// ─── More options ─────────────────────────────────────────────────────────────
import moreOptionsEs from '@/features/more-options/locales/moreOptions.es.json'
import moreOptionsEn from '@/features/more-options/locales/moreOptions.en.json'
import moreOptionsPt from '@/features/more-options/locales/moreOptions.pt.json'

// ─── Compliance ───────────────────────────────────────────────────────────────
import complianceEs from '@/features/compliance/locales/compliance.es.json'
import complianceEn from '@/features/compliance/locales/compliance.en.json'
import compliancePt from '@/features/compliance/locales/compliance.pt.json'

// ─── Shared UI components ─────────────────────────────────────────────────────
import uiEs from '@/components/ui/locales/ui.es.json'
import uiEn from '@/components/ui/locales/ui.en.json'
import uiPt from '@/components/ui/locales/ui.pt.json'

export const TRANSLATION_REGISTRY: TranslationRegistry = {
  auth:          { es: authEs,           en: authEn,           pt: authPt           },
  dashboard:     { es: dashboardEs,      en: dashboardEn,      pt: dashboardPt      },
  layout:        { es: layoutEs,         en: layoutEn,         pt: layoutPt         },
  transactions:  { es: transactionsEs,   en: transactionsEn,   pt: transactionsPt   },
  balances:      { es: balancesEs,       en: balancesEn,       pt: balancesPt       },
  sendMoney:     { es: sendMoneyEs,      en: sendMoneyEn,      pt: sendMoneyPt      },
  notifications: { es: notificationsEs,  en: notificationsEn,  pt: notificationsPt  },
  profile:       { es: profileEs,        en: profileEn,        pt: profilePt        },
  profiles:      { es: profilesEs,       en: profilesEn,       pt: profilesPt       },
  settings:      { es: settingsEs,       en: settingsEn,       pt: settingsPt       },
  register:      { es: registerEs,       en: registerEn,       pt: registerPt       },
  moreOptions:   { es: moreOptionsEs,    en: moreOptionsEn,    pt: moreOptionsPt    },
  compliance:    { es: complianceEs,     en: complianceEn,     pt: compliancePt     },
  ui:            { es: uiEs,             en: uiEn,             pt: uiPt             },
}
